import React, {useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useTitle} from '../../function';
import {HomeContainer} from '../../styled/HomeStyle';
import {Header} from '../common';
import {useSelector} from "react-redux";
import styled, {useTheme} from "styled-components";
import ServerStatusErrorbox from "../common/Error/StatusError";
import NewSearch from "../common/NewSearch";
import {home_ad_conetne} from "../../ad/bidrich";
import useAdHooks from "../../common/hooks/useAdHooks";
import UseSetCanonical from "../../common/hooks/useSetCanonical";
import HomeNoticeBoard from "./HomeNoticeBoard/HomeNoticeBoard";
import VenatusAd from "../ad/VenatusAd";
import BottomStickAd from "../ad/BottomStickAd";
import RightRailAd from "../ad/RightRailAd";
import LeftRailAd from "../ad/LeftRailAd";
import usePopUpHooks from "../../common/hooks/usePopUpHooks";
import HomeNotice from "./HomeNotice";
import HomeEventNotice from "../common/Notice/HomeEventNotice";


const AdSection = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 970px;
    height: 250px;
`;

const BannerWrapper = styled.div`
    margin: 0 0 60px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
`;

const ColumnBox = styled.div`
    display: flex;
    flex-direction: column;
`;

const Wrapper = styled(ColumnBox)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    position: relative;
`;

const BoardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: 60px;
`;

// const testTierList = ['challenger','grandmaster','master','diamond','emerald','platinum','gold','silver','bronze','iron','unranked'];

const Home = () => {
    UseSetCanonical();

    const {t, i18n} = useTranslation();
    const titleUpdate = useTitle('Loading...');
    const notice = useSelector((state) => state?.imageStore.notice);
    const country = useSelector((state) => state?.imageStore.country);
    // const argumentsInfo = useSelector((state) => state?.imageStore.argumentsInfo);
    useAdHooks(home_ad_conetne);
    const theme = useTheme();
    const currentLang = useSelector((state) => state.translation.lang)

    const [openFeedback, setOpenFeedback] = useState(false);
    setTimeout(() => titleUpdate(t('header.title')), 500);


    // if(true) {
    //     return (
    //         <Wrapper>
    //             {argumentsInfo.map((data) => {
    //                 return (
    //                     <FlexBox>
    //                         <ArgumentImage imgId={data.id} key={data.id} width={48} height={48}/>
    //                     </FlexBox>
    //
    //                 )
    //             })}
    //         </Wrapper>
    //     )
    // }


    const onClickRiotMore = () => {
        if (currentLang === 'KOR') {
            return window.open('https://www.leagueoflegends.com/ko-kr/news/tags/patch-notes/')
        } else if (currentLang === 'ja') {
            return window.open('https://www.leagueoflegends.com/ja-jp/news/tags/patch-notes/')
        }
        return window.open('https://www.leagueoflegends.com/en-us/news/tags/patch-notes/')

    }


    const onClickDeeplolMore = () => {
        if (currentLang === 'KOR') {
            return window.open('https://deeplol-notice.notion.site/2aa360ac56404feba05e3ee4643ef758?v=2b9f8c6b16a4449d91b64c931a676717')
        } else if (currentLang === 'ja') {
            return window.open('https://deeplol-notice.notion.site/13ff4d23843f8059b5faeefef1c5b4dc?v=13ff4d23843f813b87fc000cb7abba28')
        }
        return window.open('https://deeplol-notice.notion.site/22ccbbf31911418f90d1571fd3bfa745?v=e439086776eb4a5ab7a9d3b939c61e4d')
    }


    return (
        <Wrapper country={country}>
            {/*Rich*/}
            <ColumnBox>
                <Header
                    isHome={true}
                    setOpenView={setOpenFeedback}
                    openView={openFeedback}
                />
                <ServerStatusErrorbox/>
            </ColumnBox>
            <HomeContainer>
                <LeftRailAd/>
                <div className="home" id={'home_content_wrapper'}>
                    <MainBanner/>
                    <BannerWrapper>
                        <HomeNotice/>
                        <NewSearch home/>
                    </BannerWrapper>

                    {/*<HomeVideoBannerWrapper/>*/}
                    <AdSection className={''} id={'home_content_bottom_ad_box'} data-ad={'billboard'}>
                        <VenatusAd placementName={'billboard'}/>
                    </AdSection>
                    <BoardWrapper>
                        <HomeNoticeBoard title={'RIOT'}
                                         list={notice?.riot_notice_list}
                                         onClickMore={onClickRiotMore}
                        />
                        <HomeEventNotice title={'DEEPLOL'}
                                         list={notice?.deeplol_notice_list}
                                         onClickMore={onClickDeeplolMore}
                        />
                    </BoardWrapper>
                </div>
                <RightRailAd/>
            </HomeContainer>
            <BottomStickAd/>
            {currentLang === 'KOR'
                &&
                <PopUpController/>
            }
        </Wrapper>
    );
};

const MainAbsolute = styled.div`
    top: -34px;
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const MainBanner = () => {
    const currentLang = useSelector((state) => state.translation.lang);
    const theme = useTheme();

    // if (currentLang === 'ja') {
    //     return (
    //         <h2>
    //             <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Home_JP'}
    //                id={'add_To_Home_Banner_JP'} target={'_blank'}>
    //                 <img src={`images/ad/moba_home_jp.png`} alt="DEEPLOL" width={600}
    //                 />
    //             </a>
    //         </h2>
    //     )
    //
    // }
    //
    // if (currentLang !== 'KOR') {
    //     return (
    //         <h2>
    //             <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Home'}
    //                id={'add_To_Home_Banner'} target={'_blank'}>
    //                 <img src={`images/ad/moba_home.png`} alt="DEEPLOL" width={600}
    //                 />
    //             </a>
    //         </h2>
    //     )
    //
    // }

    return (
        <div style={{position: 'relative', width: '100%',height:298}}>
            <MainAbsolute>
                <img
                    src={`${theme.icon.path}/2026/main_fall.png`}
                    width={645}
                    height={350}
                    alt={''}
                />
            </MainAbsolute>
            {/*<a target={'_blank'} href={'https://www.sooplive.co.kr/station/mingyeolhee'}>*/}
            {/*    <img*/}
            {/*        src={`/images/banner/mang_main_banner.png`}*/}
            {/*        width={600}*/}
            {/*        alt={''}*/}
            {/*    />*/}
            {/*</a>*/}

        </div>
    )
}
const PopUpController = () => {
    const currentLang = useSelector((state) => state.translation.lang);
    const popUpState = useMemo(() => {
        try {
            // const state = localStorage.getItem('popUpState');
            // const numberState = Number(state);
            // if (!state) {
            //     localStorage.setItem('popUpState', "1");
            //     return 1;
            // }
            // if (numberState + 1 > 2) {
            //     localStorage.setItem('popUpState', "1");
            //     return 1;
            // }
            // localStorage.setItem('popUpState', numberState + 1)
            // return numberState + 1
            //
            return 1
        } catch (e) {
            return 0
        }
    }, []);

    const popUpCalc = (time, item) => {
        try {
            if (!time) {
                return true;
            }
            const numberTime = Number(time)
            const nowTime = new Date(Date.now());
            const nextDay = new Date(nowTime.getFullYear(), nowTime.getMonth(), nowTime.getDate() + 1);

            if (numberTime > nextDay.getTime()) {
                localStorage.setItem(item, nextDay.getTime().toString())
            }

            if (numberTime > Date.now()) {
                return false;
            }
            return true
        } catch (e) {
            return true
        }
    }

    const hasDate = useMemo(() => {
        try {
            if (popUpState === 1) {
                return popUpCalc(localStorage.getItem('popup2'), 'popup2')
            }
            return true
        } catch (e) {
            return true
        }
    }, []);


    if (currentLang !== 'KOR') {
        return null
    }

    const startMonth = 10
    const startDate = 29;
    const endMonth = 11
    const endDate = 2

    const start = new Date(2026, startMonth - 1, startDate).getTime()
    const end = new Date(2026, endMonth - 1, endDate + 1).getTime()

    if (hasDate && popUpState === 1) {
        if (Date.now() >= start && Date.now() < end) {
            return <PopUp/>
        }
    }
    return null

}

const PopUpWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.5);
`;

const PopUpBoxGeneral = styled.div`
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
`;
const PopUpBox = styled(PopUpBoxGeneral)`
    max-width: 500px;
    width: 100%;
`;


const ButtonBoxWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
`;

const ButtonBox = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 15px 0;
    color: #000;
    font-weight: bold;
    flex: 1;

    &:hover {
        background-color: #F1F3F9;
    }

    &:first-of-type {
        border-right: 1px solid #C3D1DC;
    }
`;

const AdContent = styled.div`
    .banner-img {
        width: 100%;
        height: auto;
    }
`;

const PopUp = () => {
    const {onClickDisableWeek, ref, visible, onClickClose} = usePopUpHooks({itemName: 'popup2'});

    if (!visible) {
        return null
    }
    // const secondPopUp = new Date(2026, 8 - 1, 24).getTime();
    //
    // if (secondPopUp <= Date.now()) {
    //     return (
    //         <PopUpWrapper>
    //             <PopUpBox>
    //                 <AdContent>
    //                     <a href={'https://abr.ge/uv6v8a'}
    //                        target={'_blank'} rel={'noreferrer'} className={'add_to_popup'} id={'add_to_Popup'} data-testid={'popup-2'}>
    //                         <img src={'./images/ad/ad_popup2.jpg'} width={500} height={500} sizes={''}
    //                              className={'banner-img'} alt={''}/>
    //                     </a>
    //                 </AdContent>
    //                 <ButtonBoxWrapper>
    //                     <ButtonBox onClick={onClickDisableWeek}>
    //                         하루 동안 다시 보지 않기
    //                     </ButtonBox>
    //                     <ButtonBox onClick={onClickClose}>
    //                         닫기
    //                     </ButtonBox>
    //                 </ButtonBoxWrapper>
    //             </PopUpBox>
    //         </PopUpWrapper>
    //     )
    // }

    return (
        <PopUpWrapper>
            <PopUpBox>
                <AdContent>
                    <a href={'https://mho.onelink.me/TRA1/hfi4n69i'}
                       target={'_blank'} rel={'noreferrer'} className={'add_to_popup'} id={'add_to_Popup'}
                       data-testid={'popup-1'}>
                        <img src={'./images/ad/ad_popup.jpg'} width={500} height={500} sizes={''}
                             className={'banner-img'} alt={''}/>
                    </a>
                </AdContent>
                <ButtonBoxWrapper>
                    <ButtonBox onClick={onClickDisableWeek}>
                        하루 동안 다시 보지 않기
                    </ButtonBox>
                    <ButtonBox onClick={onClickClose}>
                        닫기
                    </ButtonBox>
                </ButtonBoxWrapper>
            </PopUpBox>
        </PopUpWrapper>
    )
}


export default Home;
